var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasNode)?_c('div',[_c('VNode',{attrs:{"node":_vm.node,"item":_vm.item}})],1):_c('span',[_vm._v("\n  "+_vm._s(_vm.hasValue ? _vm.format(this.localValue) : 'N/D')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5814804c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/datagrid/NxDataGridRow.vue
// module id = null
// module chunks = 